import React, { Component, Fragment, useState } from 'react';
import styled, { css } from 'styled-components';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import Typist from 'react-typist';

import Title from '../shared/Title';
import Text from '../shared/Text';
import Button from '../shared/Button';
import Navbar from '../shared/Navbar';
import Footer from './Footer';
import Section from './Section';
import QuickResourceCard from './QuickResourceCard';
import Modal from '../shared/Modal';
import Row from './Row';
import Map from './Map';
import Island from '../shared/Island';
import { breakpoints, palette, flexCenter } from '../../constants/styles';
import { mp, getCampaign } from '../../constants/utils';
import Graphic from './Graphic';

import FloatingContact from '../shared/FloatingContact';

import { PlanModalMaria, PlanModalEmmanuel } from '../shared/landingStyles';

import CTAButton from '../shared/CTAButton';
import GetStarted from './GetStarted';
import MySwiper from './Swiper';
import WhatsappCTA from '../shared/WhatsappCTA';
import { Mixpanel } from '../mixpanel';

// AWS Assets used in landing page
const Finauta = 'https://s3.us-east-2.amazonaws.com/finauta/art/finauta.png';
const FinautaBlog = 'https://s3.us-east-2.amazonaws.com/finauta/avatars/finauta-blog.png';
const FintonicApp = 'https://s3.us-east-2.amazonaws.com/finauta/avatars/fintonic-app.png';
const FishingMobile = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishingMobile.png';
const FishingDesktop = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishing.png';
const FinautaShip = 'https://s3.us-east-2.amazonaws.com/finauta/art/finautaShipSmall.png';
const PlanMaria = 'https://s3.us-east-2.amazonaws.com/finauta/displayMaps/planMaria.png';
const RetiroEmmanuel = 'https://s3.us-east-2.amazonaws.com/finauta/displayMaps/emmanuelRetiro.png';

const StyledHome = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledFishingSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;

  ${breakpoints.tabletLandscape} {
    flex-direction: row-reverse;
  }

  ${breakpoints.desktop} {
    width: 100%;
    margin-top: -20vh;
    max-width: 1060px;
  }
`;

const Sailer = styled.img.attrs({
  src: 'https://s3.us-east-2.amazonaws.com/finauta/art/finauta.png',
})`
  align-self: center;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-top: 5em;

  ${breakpoints.tablet} {
    max-width: 220px;
  }
  ${breakpoints.tabletLandscape} {
    max-width: 200px;
    height: 210px;
  }

  ${breakpoints.desktop} {
    max-width: 250px;
    margin-right: 20px;
    align-self: center;
  }
`;

const Bear = styled.img.attrs({
  src: 'https://s3.us-east-2.amazonaws.com/finauta/art/osito.png',
})`
  margin-top: 30px;
  align-self: center;
  max-width: 220px;
  height: auto;
  position: relative;
  align-self: center;

  ${breakpoints.mobileLandscape} {
    max-width: 180px;
  }
  ${breakpoints.tablet} {
    max-width: 220px;
  }
  ${breakpoints.tabletLandscape} {
    max-width: 200px;
  }

  ${breakpoints.desktop} {
    max-width: 250px;
    margin-right: 20px;
    align-self: center;
  }

  ${breakpoints.larger} {
    margin-right: 0px;
  }
`;

const lighthouseStyles = css`
  z-index: 1000;
  justify-content: flex-end;
  padding: 0px;
  margin-top: -150px;

  ${breakpoints.mobileLandscape} {
    margin-top: -220px;
    margin-left: 10px;
  }

  ${breakpoints.tablet} {
    margin-top: -30px;
    margin-left: -20px;
  }

  ${breakpoints.desktop} {
    margin-top: 100px;
    margin-left: -3px;
  }
`;

const ImgContainer = styled.div`
  ${flexCenter}
`;

const ResourcesContainer = styled.div`
  ${breakpoints.tabletLandscape} {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    max-width: 850px;
  }
`;

const FinautaAlRescate = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  ${breakpoints.mobileLandscape} {
    margin-top: 0px;
  }

  ${breakpoints.tabletLandscape} {
    align-items: center;
    margin-bottom: 10px;
  }
`;

const StyledMariaPlan = styled.img.attrs({
  src: PlanMaria,
})`
  align-self: center;
  margin-right: 50px;
  height: auto;
  width: 90%;
  max-width: 320px;

  ${breakpoints.mobileLandscape} {
    max-width: 350px;
  }
`;

const StyledEmmanuelRetiro = styled.img.attrs({
  src: RetiroEmmanuel,
})`
  align-self: center;
  margin-right: 50px;
  height: auto;
  width: 90%;
  max-width: 320px;

  ${breakpoints.mobileLandscape} {
    max-width: 450px;
  }
`;

const StyledFinauta = styled.img.attrs({
  src: Finauta,
})`
  align-self: flex-end;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;

  ${breakpoints.mobileLandscape} {
    max-width: 180px;
    margin-top: 40px;
  }
  ${breakpoints.tablet} {
    max-width: 220px;
  }
  ${breakpoints.tabletLandscape} {
    max-width: 200px;
  }

  ${breakpoints.desktop} {
    max-width: 250px;
    margin-right: 20px;
    align-self: center;
  }
`;

const StyledShip = styled.img.attrs({
  src: FinautaShip,
})`
  width: 95%;
  margin-top: -20px;
  margin-bottom: 0px;
  max-width: 500px;

  ${breakpoints.tabletLandscape} {
    margin-top: 50px;
    max-width: 480px;
    max-height: 400px;
  }

  ${breakpoints.desktop} {
    margin-top: 60px;
  }
`;

const emmitCTAConstants = [
  'Header | Conversemos',
  'Tools | Metas',
  'Tools | Retiro',
  'ModalMetas | Metas',
  'ModalRetiro | Retiro',
  'Bottom | Conversemos',
  'Me interesa | Comprar o Rentar',
  'Me interesa | Refinanciamiento',
];

const StyledFishingGraphic = css`
  width: 300px;

  ${breakpoints.mobileLandscape} {
    width: 310px;
    margin-top: 2em;
  }

  ${breakpoints.tablet} {
    margin-top: 100px;
    width: 430px;
  }

  ${breakpoints.tabletLandscape} {
    width: 320px;
    align-self: flex-end;
    margin-left: 20px;
    margin-top: 75px;
  }

  ${breakpoints.desktop} {
    width: 430px;
  }
`;

const StyledInitialCTA = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  min-height: 280px;
  margin-top: 50px;

  ${breakpoints.mobileLandscape} {
    align-items: center;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 0px;
    margin-left: 20px;
    align-items: flex-start;
  }

  ${breakpoints.desktop} {
    width: 100%;
  }

  ${breakpoints.desktop2} {
    margin-left: 60px;
  }
`;

const StyledHomeCTA = css`
  width: 100%;
  ${breakpoints.tabletLandscape} {
    width: fit-content;
  }
`;

const StyledSecondTitle = css`
  ${breakpoints.mobileLandscape} {
    max-width: 380px;
    text-align: center;
  }

  ${breakpoints.tabletLandscape} {
    max-width: 410px;
    text-align: center;
    margin-right: 20px;
    font-size: 2.2em;
  }

  ${breakpoints.desktop} {
    max-width: 440px;
    width: 500px;
    justify-self: flex-end;
  }
`;

const StyledUnderline = styled.u`
  text-decoration: none;
  border-bottom: 1.5px solid ${palette.finautaOldOrange};
`;

const StyledDivision = styled.hr`
  display: block;
  width: 80vw;
  height: 0px;
  margin-top: -20px;
  border-top: 1px solid ${palette.primaryColor}2b;
  border-bottom: none;

  ${breakpoints.tablet} {
    display: none;
  }
`;

const StyledInitialCTATitle2 = css`
  display: none;
  position: absolute;
  width: 90vw;
  top: -50px;
  left: 0px;

  ${breakpoints.tabletLandscape} {
    display: inline-flex;
    top: -80px;
  }
`;

const StyledInitialCTATitle = css`
  z-index: 100000;
  position: absolute;
  top: 35px;
  left: 20px;
  min-height: 200px;
  width: 92vw;

  ${breakpoints.mobileLandscape} {
    line-height: 1.2;
    margin-top: 0.5em;
  }

  ${breakpoints.tablet} {
    text-align: center;
  }

  ${breakpoints.tabletLandscape} {
    // text-align: left;
    // min-height: 60px;
    // width: 92vw;
    // margin-left: 40px;
    // margin-top: 50px;
    display: none;
  }
`;

const FirstSection = styled(Section)`
  height: 80vh;
  justify-content: center;
  min-height: 600px;
  max-height: 610px;

  ${breakpoints.mobileLandscape} {
    height: 60vh;
  }

  ${breakpoints.tablet} {
    height: 90vh;
    min-height: 700px;
    max-height: 750px;
  }

  ${breakpoints.tabletLandscape} {
    height: 90vh;
    min-height: 560px;
    max-height: 580px;
  }

  ${breakpoints.desktop} {
    height: 80vh;
    margin-top: 7em;
  }
`;

const StyledModalContent = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CTAGetMyPlan = css`
  margin-top: 15px;
  margin-right: 40px
  cursor:pointer;
  height: 35px;
  font-size: 16px;
  max-width: 260px;

  background-color: #26bd8d;

  &:hover {
    background-color: ${palette.secondaryColor};
  }

  ${({ alternative }) =>
    alternative &&
    css`
      background-color: ${palette.finautaOrange};
    `}
`;

const StyledTravesiaTitle = css`
  margin-top: 3em;
  max-width: 22rem;
  ${breakpoints.mobileLandscape} {
    margin-top: 2em;
  }
`;

const StyledPlaticaTitle = css`
  max-width: 24rem;
`;

const FlexColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
`;

const NoStressText = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;

  ${breakpoints.tablet} {
    align-self: center;
    margin-top: 1em;
    align-items: center;
    width: 540px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 2em;
  }

  ${breakpoints.desktop} {
    width: 580px;
    align-items: flex-start;
  }
`;

const WinWinTextContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;

  ${breakpoints.tablet} {
    margin-top: 1em;
    width: 540px;
    align-self: center;
  }

  ${breakpoints.desktop} {
    width: 580px;
  }
`;

const WinWinText = css`
  text-align: left;

  ${breakpoints.tabletLandscape} {
    text-align: left;
  }
`;

const NoStressImg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  ${breakpoints.tabletLandscape} {
    align-items: flex-end;
    padding-right: 5vw;
    margin-top: 30px;
    align-self: flex-end;
    margin-right: 13vw;
  }

  @media screen and (min-width: 1200px) {
    align-self: center;
    margin-right: 0px;
    margin-left: 20vw;
  }

  ${breakpoints.larger} {
    margin-left: 0px;
  }
`;

const StyledNoStressText = css`
  text-align: left;
  margin-bottom: ${({ first }) => first && '1em'};
`;

const StyledSubtitle = css`
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;

  ${breakpoints.mobileLandscape} {
    margin-top: 1em;
    width: 320px;
    text-align: center;
  }

  ${breakpoints.tabletLandscape} {
    max-width: 310px;
    text-align: left;
  }
`;

const StyledFirstSectionRow = css`
  margin-top: 1em;

  ${breakpoints.tabletLandscape} {
  }
`;

const SecondSection = styled(Section)`
  min-height: 650px;
  height: 80vh;
  max-height: 680px;

  ${breakpoints.mobileLandscape} {
    min-height: 600px;
    max-height: 640px;
  }

  ${breakpoints.tablet} {
    min-height: 700px;
  }
`;

const SecondSectionTitleAndImage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  ${breakpoints.tabletLandscape} {
    flex-direction: column-reverse;
  }
`;

const ThirdSection = styled(Section)`
  min-height: 570px;
  height: 80vh;
  max-height: 650px;

  ${breakpoints.mobileLandscape} {
    min-height: 440px;
    max-height: 500px;
  }

  ${breakpoints.tablet} {
    max-height: 550px;
  }
`;

const ThirdSectionTitle = css`
  text-align: center;
  margin-top: 2em;
  ${breakpoints.mobileLandscape} {
    margin-top: 2em;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 1em;
  }

  ${breakpoints.desktop} {
    margin-top: 3em;
  }
`;

const FourthSection = styled(Section)`
  min-height: 940px;
  max-height: 980px;
  height: 80vh;

  ${breakpoints.mobileLandscape} {
    min-height: 860px;
    max-height: 890px;
  }

  ${breakpoints.tablet} {
    min-height: 840px;
  }

  ${breakpoints.tabletLandscape} {
    min-height: 880px;
  }

  ${breakpoints.desktop} {
    min-height: 680px;
    max-height: 690px;
  }
`;

const FifthSection = styled(Section)`
  ${breakpoints.tablet} {
    height: 870px;
  }
`;

const StyledInitialCTAButton = css`
  margin-top: 20px;
  align-self: flex-start;
`;

const StyledCTAButton = css`
  margin-top: 20px;
  align-self: center;
`;

const StyledNoStressButton = css`
  align-self: center;

  ${breakpoints.tablet} {
    margin-top: 1.5em;
  }
`;

const NoStressTitle = css`
  text-align: center;
  ${breakpoints.tabletLandscape} {
    align-self: flex-end;
  }
  ${breakpoints.larger} {
    align-self: center;
  }
`;

const StyledCTAWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

class Home extends Component {
  state = {
    openModalMaria: false,
    openModalEmmanuel: false,
    isOpened: false,
    expanded: false,
    callVisible: false,
    upperCTAClosed: false,
  };

  componentDidMount() {
    mp(`[${getCampaign(window.location.href)}] | Landing | Entra`);
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp(`[${getCampaign(window.location.href)}] | Landing | Se va`);
    };
  };

  /*
  toggleModalToolInProgress1 = () => {
    this.setState(state => ({ openModalToolInProgress1: !state.openModalToolInProgress1 }));
  }
  */

  toggleModalMaria = () => {
    this.setState((state) => ({ openModalMaria: !state.openModalMaria }));
  };

  toggleModalEmmanuel = () => {
    this.setState((state) => ({ openModalEmmanuel: !state.openModalEmmanuel }));
  };

  handleCloseUpperCTA = () => {
    this.setState((state) => ({ upperCTAClosed: !state.upperCTAClosed }));
  };

  render() {
    const { openModalEmmanuel, openModalMaria } = this.state;
    return (
      <Fragment>
        <Helmet>
          <script src="https://unpkg.com/react-id-swiper@2.3.1/lib/react-id-swiper.min.js" />
          <script src="https://unpkg.com/react-id-swiper@2.3.1/lib/react-id-swiper.js" />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.css"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.min.css"
          />
        </Helmet>
        <Modal
          show={openModalMaria}
          onCloseModal={this.toggleModalMaria}
          // TODO: Define a theme for these types of modals,
          // and then add it to the Modal component so we can
          // access it wherever.
          styles={PlanModalMaria}
        >
          {() => (
            <StyledModalContent>
              <Title
                level={3}
                styles={css`
                  margin-right: 50px;
                `}
              >
                Mapa financiero de María
              </Title>
              <StyledMariaPlan />
              {/* <Link to="/metas" style={{ width: '100%', display: 'flex', flexDirection: 'column', textDecoration: 'none', alignItems: 'center' }}>
                <Button
                  onClick={() => {
                    this.emmitCTAClicked(3);
                  }}
                  styles={CTAGetMyPlan}
                  noShadow
                >
                  <b>Obtener mi mapa financiero</b>
                </Button>
              </Link> */}
            </StyledModalContent>
          )}
        </Modal>
        <Modal
          show={openModalEmmanuel}
          onCloseModal={this.toggleModalEmmanuel}
          styles={PlanModalEmmanuel}
        >
          {() => (
            <StyledModalContent>
              <Title
                level={3}
                styles={css`
                  margin-right: 50px;
                `}
              >
                Resultados de Emmanuel
              </Title>
              <StyledEmmanuelRetiro />
              <Link
                to="/retiro"
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  textDecoration: 'none',
                  alignItems: 'center',
                }}
              >
                <Button styles={CTAGetMyPlan} noShadow>
                  <b>Calcular mi retiro</b>
                </Button>
              </Link>
            </StyledModalContent>
          )}
        </Modal>
        <StyledHome>
          <Navbar />
          <FirstSection>
            <StyledFishingSection>
              <StyledInitialCTA>
                <TitleColumn>
                  <Title level={1} styles={StyledInitialCTATitle}>
                    Tu plan para
                    <Typist
                      className="my-custom-typist-text"
                      cursor={{
                        show: true,
                        blink: true,
                        element: '|',
                        hideWhenDone: false,
                      }}
                    >
                      <Typist.Delay ms={1000} />
                      <span style={{ color: palette.terciaryColor }}>lograr tus metas</span>
                      <Typist.Delay ms={1000} />
                      <Typist.Backspace count={16} delay={500} />
                      <span style={{ color: palette.terciaryColor }}>pagar tus deudas</span>
                      <Typist.Delay ms={1000} />
                      <Typist.Backspace count={16} delay={500} />
                      <span style={{ color: palette.terciaryColor }}>el retiro</span>
                      <Typist.Delay ms={1000} />
                      <Typist.Backspace count={9} delay={500} />
                      <span style={{ color: palette.terciaryColor }}>protegerte</span>
                      <Typist.Delay ms={1000} />
                      <Typist.Backspace count={10} delay={500} />
                      <span style={{ color: palette.terciaryColor }}>relajarte</span>
                      <Typist.Delay ms={1500} />
                      <Typist.Backspace count={9} delay={500} />
                      <span style={{ color: palette.terciaryColor }}>lograr tus metas</span>
                    </Typist>
                  </Title>
                </TitleColumn>
                <Row styles={StyledFirstSectionRow}>
                  <Graphic
                    initialHeight={219}
                    mP={FishingMobile}
                    mL={FishingMobile}
                    tP={FishingDesktop}
                    tL={FishingDesktop}
                    d={FishingDesktop}
                    l={FishingDesktop}
                    styles={StyledFishingGraphic}
                  />
                  <FlexColumn>
                    <Title level={1} styles={StyledInitialCTATitle2}>
                      Tu plan para
                      <Typist
                        cursor={{
                          show: true,
                          blink: true,
                          element: '|',
                          hideWhenDone: false,
                        }}
                        className="custom-typist"
                      >
                        <Typist.Delay ms={1000} />
                        <span style={{ color: palette.terciaryColor }}>lograr tus metas</span>
                        <Typist.Delay ms={1000} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>pagar tus deudas</span>
                        <Typist.Delay ms={1000} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>el retiro</span>
                        <Typist.Delay ms={1000} />
                        <Typist.Backspace count={9} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>protegerte</span>
                        <Typist.Delay ms={1000} />
                        <Typist.Backspace count={10} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>relajarte</span>
                        <Typist.Delay ms={1500} />
                        <Typist.Backspace count={9} delay={500} />
                        {/* Ends first loop */}
                        <span style={{ color: palette.terciaryColor }}>lograr tus metas</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>pagar tus deudas</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>el retiro</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={9} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>protegerte</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={10} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>relajarte</span>
                        <Typist.Delay ms={1500} />
                        <Typist.Backspace count={9} delay={500} />
                        {/* Ends second loop */}
                        <span style={{ color: palette.terciaryColor }}>lograr tus metas</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>pagar tus deudas</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={16} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>el retiro</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={9} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>protegerte</span>
                        <Typist.Delay ms={500} />
                        <Typist.Backspace count={10} delay={500} />
                        <span style={{ color: palette.terciaryColor }}>relajarte</span>
                        {/* Ends third loop */}
                      </Typist>
                    </Title>
                    <Text type="subtitle1" styles={StyledSubtitle}>
                      Lleva tus finanzas personales al siguiente nivel, nosotros te acompañamos
                    </Text>
                    <StyledCTAWrapper>
                      <CTAButton
                        buttonText={'Comenzar'}
                        buttonStyles={StyledInitialCTAButton}
                        internalLink={'/router'}
                        event={`[${getCampaign(
                          window.location.href,
                        )}] | Landing | Inicia Diagnostico`}
                      />
                    </StyledCTAWrapper>
                  </FlexColumn>
                </Row>
              </StyledInitialCTA>
            </StyledFishingSection>
          </FirstSection>
          <SecondSection>
            <Island type="first3" />
            <Island type="first" />
            <NoStressImg>
              <SecondSectionTitleAndImage>
                <ImgContainer>
                  <Bear />
                </ImgContainer>
                <Title level={2} styles={NoStressTitle}>
                  Cero estrés
                </Title>
              </SecondSectionTitleAndImage>
            </NoStressImg>
            <NoStressText>
              <Text type="sectionText" style={{ marginBottom: '1em' }} styles={StyledNoStressText}>
                <b>Nadie nos enseña qué hacer con nuestro dinero </b>
                para lograr nuestras metas.
              </Text>
              <Text type="sectionText" styles={StyledNoStressText}>
                Tu plan te dará recomendaciones sobre
                <b> cómo </b>
                pagar tus deudas,
                <b> cuánto </b>
                ahorrar,
                <b> dónde </b>
                invertir y<b> cómo </b>
                protegerte.
              </Text>
              <CTAButton
                buttonText={'Comenzar'}
                buttonStyles={StyledCTAButton}
                internalLink={'/router'}
                event={`[${getCampaign(window.location.href)}] | Landing | Inicia Diagnostico`}
              />
            </NoStressText>
            <Island type="fourth" />
            <Island type="first2" />
          </SecondSection>
          <ThirdSection>
            <Title level={2} styles={ThirdSectionTitle}>
              ¿Asesoría o venta?
            </Title>
            <WinWinTextContainer>
              <Text type="sectionText" styles={WinWinText}>
                En México, prácticamente
                <b> los “asesores financieros” son vendedores </b>. Por lo que ven primero por su
                comisión que por ti.
              </Text>
              <br />
              <Text type="sectionText" styles={WinWinText}>
                En Finauta,
                <b> al ser independientes </b>, vemos primero por ti.
              </Text>
              <br />
              <Text type="sectionText" styles={WinWinText}>
                Porque creemos en el ganar-ganar.
                <b> Nosotros ganamos si tú logras tus metas.</b>
              </Text>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <CTAButton
                  buttonText={'Comenzar'}
                  buttonStyles={StyledCTAButton}
                  internalLink={'/router'}
                  event={`[${getCampaign(window.location.href)}] | Landing | Inicia Diagnostico`}
                />
              </div>
            </WinWinTextContainer>
          </ThirdSection>
          <FourthSection>
            <Island type="second2" />
            <Sailer />
            <Title align="center" level={2}>
              Navega con Finauta
            </Title>
            <MySwiper />
          </FourthSection>
          <FifthSection>
            <Island type="third" />
            <Title align="center" level={2} styles={StyledTravesiaTitle}>
              Tu travesía comienza aquí
            </Title>
            <CTAButton
              buttonText={'Comenzar'}
              buttonStyles={StyledCTAButton}
              internalLink={'/router'}
              event={`[${getCampaign(window.location.href)}] | Landing | Inicia Diagnostico`}
            />
            <Map />
            <Island type="last" />
          </FifthSection>
          <Section styles={lighthouseStyles}>
            <LazyLoad height={390} offset={1000}>
              <Island type="lighthouse" />
            </LazyLoad>
          </Section>
          <Section
            styles={css`
              background-color: ${palette.sweetGray};
            `}
          >
            <Title align="center" level={2}>
              Sigue aprendiendo
            </Title>
            <ResourcesContainer>
              <QuickResourceCard
                image={FinautaBlog}
                title="Nuestro Blog"
                description="Conoce cómo podemos simplificar tus finanzas personales"
                link="http://medium.com/@finauta"
              />
              <QuickResourceCard
                image={FintonicApp}
                title="Fintonic"
                description="Una app para gestionar los gastos de todas tus tarjetas"
                link="https://www.fintonic.mx/es-MX/inicio/"
              />
            </ResourcesContainer>
          </Section>
          <FloatingContact />
          <Footer />
          {/* <WhatsappCTA message="Hola 😁" /> */}
        </StyledHome>
      </Fragment>
    );
  }
}

export default Home;
